import { fetchWrapper } from '../../../reducers/fetch'
import { UserCoupon } from '../../user-coupons/userCoupons.slice'
import { apiAxios } from '@/api'
import { TAXFYLE_PORTAL_TRY_AGAIN_ERROR } from '@/features/taxes/annual-taxes/constants'

export const FETCH_TAX_CONSULTATION_URL = 'FETCH_TAX_CONSULTATION_URL'
/**
 * Taxfyle link expires after 5 minutes and is single use
 */
export const fetchTaxConsultationUrl = (jobId: string) =>
  fetchWrapper({
    fetchKey: FETCH_TAX_CONSULTATION_URL,
    defaultErrorMessage: TAXFYLE_PORTAL_TRY_AGAIN_ERROR,
    fetchFunction: async () => {
      const json = await apiAxios.get<{ link: string }>(
        `/finances/api/v1/tax_consultations/${jobId}/link`
      )
      return { url: json.data.link }
    },
  })

export const FETCH_NEXT_TAX_CONSULTATION_COUPON_KEY =
  'FETCH_NEXT_TAX_CONSULTATION_COUPON_KEY'
export const fetchNextTaxConsultationCoupon = () =>
  fetchWrapper({
    fetchKey: FETCH_NEXT_TAX_CONSULTATION_COUPON_KEY,
    fetchFunction: async () => {
      const json = await apiAxios.get<UserCoupon | null>(
        '/finances/api/v1/tax_consultations/coupon'
      )
      return json.data
    },
  })

export const FETCH_TAX_CONSULTATION_CHECKOUT_SESSION_KEY =
  'FETCH_TAX_CONSULTATION_CHECKOUT_SESSION_KEY'
export const fetchTaxConsultationCheckoutSession = (duration: 30 | 60) =>
  fetchWrapper({
    fetchKey: FETCH_TAX_CONSULTATION_CHECKOUT_SESSION_KEY,
    fetchFunction: async () => {
      const json = await apiAxios.put<{
        url: string
        internal: boolean
      }>(`/finances/api/v1/tax_consultations/request/duration/${duration}`)
      return json.data
    },
  })
